import withInputErrorMessage from '../../withInputErrorMessage';
import withOptionsSelectValueInitById from '../withOptionsSelectValueInitById';
import withFormikSelect from '../withSelectFormik';

export const options = [
   {
      value: 'ACTIVE',
      label: 'Active',
      id: 0,
      name: 'Active',
   },
   {
      value: 'INACTIVE',
      label: 'Inactive',
      id: 1,
      name: 'Inactive',
   },
];

export default withFormikSelect(withInputErrorMessage(withOptionsSelectValueInitById(options)));
